// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5533":"09bcddc2","7413":"4f2ec19a","8309":"954b5f28"}[chunkId] + ".chunk.css";
};